import Scrollbar from '@components/dataEntry/select/DropdownScrollbar';
import keyCode from '@typings/setting/keyCode.enum';
import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';

const Div = styled.div``;

type Props = {
  open: boolean;
  children: JSX.Element | JSX.Element[];
  style?: any;
  maxHeight?: number;
  itemHeight?: number;
  itemPadding?: number;
  // --- keydown 관련 props
  listMaxLength: number;
  name: string;
  activeIndex: number | null;
  setActiveIndex: (any) => void;
  handleEnter: (index?: number) => void;
  [propsName: string]: any;
};

function KeyDownScrollWrapper({
  open,
  children,
  style,
  maxHeight,
  itemHeight,
  itemPadding,
  // --- keydown 관련 props
  onKeyDownOption,
  listMaxLength,
  name,
  activeIndex,
  setActiveIndex,
  handleEnter,
  ...props
}: Props) {
  /*
   *
   *
   * 키보드의 위, 아래, 엔터 키 누를 때
   */
  function handleKeyDown(e: any) {
    const { key } = e;

    if (key === keyCode.ARROW_DOWN) {
      e.preventDefault();
      setActiveIndex!((prevState) =>
        prevState < listMaxLength! ? prevState + 1 : 0,
      );
    }

    if (key === keyCode.ARROW_UP) {
      e.preventDefault();
      setActiveIndex!((prevState) =>
        prevState > 0 ? prevState - 1 : listMaxLength!,
      );
    }

    if (key === keyCode.ENTER) {
      e.preventDefault();
      handleEnter(activeIndex ?? 0);
    }
  }

  useEffect(() => {
    if (open) document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [open, activeIndex, listMaxLength, handleEnter]);

  // 방향키 누를때 마다의 스크롤 변화
  useEffect(() => {
    if (open) {
      const scrollbar = document.getElementById(`dropdown-scrollbar-${name}`);
      if (scrollbar && activeIndex! >= 0) {
        const height = itemHeight || 30;
        const padding = itemPadding || 8;
        const heightOfPrevIndex = activeIndex! * height;
        const heightOfNowIndex = (activeIndex! + 1) * padding + padding;
        const heightofScrollStart = scrollbar.scrollTop;
        const heightOfScrollEnd = scrollbar.scrollTop + scrollbar.clientHeight;

        if (heightOfPrevIndex < heightofScrollStart) {
          scrollbar.scrollTop = heightOfPrevIndex;
        } else if (heightOfNowIndex > heightOfScrollEnd) {
          scrollbar.scrollTop =
            scrollbar.scrollTop + (heightOfNowIndex - heightOfScrollEnd);
        }
      }
    }
  }, [open, activeIndex]);

  return <Scrollbar maxheight={maxHeight}>{children}</Scrollbar>;
}

export default KeyDownScrollWrapper;
